import { Preprocessor } from './AriaSink';
import { DiagnosticLevel, TelemetryEvent } from '@ms/oteljs';

export class FullEventProcessor implements Preprocessor {
  private _fullEventsEnabled: boolean = false;
  processEvent(event: TelemetryEvent) {
    return this._fullEventsEnabled || (!!event.eventFlags && event.eventFlags.diagnosticLevel === DiagnosticLevel.BasicEvent);
  }

  public setFullEventsEnabled(enabled: boolean) {
    this._fullEventsEnabled = enabled;
  }
}
